import actions from './actions';
import { FixedPointState, FixedPoint, FixedPointPage } from './models';
import { initialPage } from '../app/basicModels';
import { EntityAdapter, createEntityAdapter } from 'redux-ngrx-entity';

const entity: EntityAdapter<FixedPoint> = createEntityAdapter<FixedPoint>();

export const fixedPointTypes = [
  { id: 'generic', name: 'Generic' },
  { id: 'pluviometer', name: 'Pluviometer' },
  { id: 'trap', name: 'Trap' }
];

export const iconTypes = [
  {
    id: 'DANGER',
    type: 'generic',
    name: 'Danger'
  },
  {
    id: 'AIRPORT',
    type: 'generic',
    name: 'Airport'
  },
  {
    id: 'POLE',
    type: 'generic',
    name: 'Pole'
  },
  {
    id: 'PLUVIOMETER',
    type: 'pluviometer',
    name: 'Pluviometer'
  },
  {
    id: 'LIGHT_TRAP',
    type: 'trap',
    name: 'Light Trap'
  },
  {
    id: 'FLAG',
    type: 'generic',
    name: 'Flag'
  },
  {
    id: 'HQ',
    type: 'generic',
    name: 'Hq'
  },
  {
    id: 'GARAGE',
    type: 'generic',
    name: 'Garage'
  },
  {
    id: 'RENEWABLE_TRAP',
    type: 'trap',
    name: 'Renewable Trap'
  },
  {
    id: 'BUS_STOP',
    type: 'generic',
    name: 'Bus Stop'
  },
  {
    id: 'RESTING_AREA',
    type: 'generic',
    name: 'Resting Area'
  },
  {
    id: 'GAS_STATION',
    type: 'generic',
    name: 'Gas Station'
  },
  {
    id: 'WARNING',
    type: 'generic',
    name: 'Warning'
  },
  {
    id: 'BRIDGE',
    type: 'generic',
    name: 'Bridge'
  },
  {
    id: 'GATE',
    type: 'generic',
    name: 'Gate'
  },
  {
    id: 'HORMONAL_TRAP',
    type: 'trap',
    name: 'Hormonal Trap'
  },
  {
    id: 'WEATHER_STATION',
    type: 'generic',
    name: 'Weather Station'
  },
  {
    id: 'CAMERA',
    type: 'generic',
    name: 'Camera'
  }
];

const initialState: FixedPointState = entity.getInitialState({
  page: {
    ...initialPage
  },
  isLoading: false,
  company_id: null,
  parent_id: null,
  error: null,
  isSaving: false,
  fixedPointSelect: null,
  fixedPointSelectLoading: false,
  fixedPointTypes,
  iconTypes,
  editPhenomenaModalActive: false,
  indicatorsModalVisible: false,
  phenomenonsOfFixedPoint: [],
  characteristicsOfFixePoint: [],
  isLoadingPhenomenonsForFixedPoint: false,
  isLoadingCharacteristicsOfFixedPoint: false,
  isDrafting: false,
  phenomenonInfo: null,
  addCharacteristicIndicatorActive: false
});

export default (state = initialState, action): FixedPointState => {
  switch (action.type) {
    case actions.LOAD_FIXEDPOINTS_BY_COMPANY:
    case actions.LOAD_INSTALLED_FIXEDPOINTS_BY_COMPANY:
      return {
        ...state,
        isLoading: true
      };

    case actions.LOAD_FIXEDPOINTS_SUCCESS:
      return entity.addAll(action.payload as FixedPoint[], {
        ...state,
        page: {
          number: 0,
          size: 0,
          pages: 0,
          total: 0,
          content: [...action.payload]
        },
        isLoading: false,
        error: null
      });

    case actions.LOAD_INSTALLED_FIXEDPOINTS_BY_COMPANY_SUCCESS:
      return entity.upsertMany((action.payload as FixedPointPage).content, {
        ...state,
        page: {
          ...state.page,
          ...action.payload
        },
        isLoading: false,
        error: null
      });

    case actions.SAVE_FIXEDPOINT:
      return {
        ...state,
        isSaving: true
      };

    case actions.SAVE_FIXEDPOINT_SUCCESS:
      return entity.upsertOne(action.payload, {
        ...state,
        isSaving: false,
        error: null,
        fixedPointSelect: action.payload
      });

    case actions.SAVE_FIXEDPOINT_FAILURE:
      return {
        ...state,
        isSaving: false,
        isDrafting: false,
        error: action.payload
      };

    case actions.UPDATE_FIXEDPOINT:
      return {
        ...state,
        isDrafting: true
      };

    case actions.SELECT_FIXEDPOINT:
      return {
        ...state,
        fixedPointSelect: action.payload,
        isDrafting: false
      };

    case actions.LOAD_FIXEDPOINT_BY_COMPANY:
      return {
        ...state,
        fixedPointSelectLoading: true,
        fixedPointSelect: null
      };

    case actions.LOAD_FIXEDPOINT_SUCCESS:
      return {
        ...state,
        fixedPointSelectLoading: false,
        fixedPointSelect: action.payload
      };

    case actions.LOAD_FIXEDPOINT_FAILURE:
      return {
        ...state,
        fixedPointSelectLoading: false,
        error: action.payload
      };

    case actions.DELETE_FIXEDPOINT_SUCCESS:
      return entity.removeOne(action.payload.id, {
        ...state,
        error: null
      });

    case actions.DELETE_FIXEDPOINT_FAILURE:
      return {
        ...state,
        error: action.payload
      };

    case actions.CLEAR_FIXED_POINT_SELECT_BY_COMPANY:
      return {
        ...state,
        fixedPointSelect: null,
        phenomenonsOfFixedPoint: []
      };

    case actions.CLEAR_PHENOMENONS_OF_FIXED_POINT:
      return {
        ...state,
        phenomenonsOfFixedPoint: []
      };

    case actions.TOGGLE_FIXED_POINT_PHENOMENA_MODAL:
      return {
        ...state,
        editPhenomenaModalActive: !state.editPhenomenaModalActive
      };
    case actions.TOGGLE_INDICATORS_PHENOMENA_MODAL:
      return {
        ...state,
        indicatorsModalVisible: !state.indicatorsModalVisible
      };

    case actions.TOGGLE_CHARACTERISTICS_INDICATORS_PHENOMENA_MODAL:
      return {
        ...state,
        addCharacteristicIndicatorActive: !state.addCharacteristicIndicatorActive,
        phenomenonInfo: action.payload
      };

    case actions.LOAD_PHENOMENONS_OF_FIXED_POINT:
      return {
        ...state,
        isLoadingPhenomenonsForFixedPoint: true
      };

    case actions.LOAD_PHENOMENONS_OF_FIXED_POINT_SUCCESS:
      return {
        ...state,
        isLoadingPhenomenonsForFixedPoint: false,
        phenomenonsOfFixedPoint: action.payload
      };

    case actions.LOAD_PHENOMENONS_OF_FIXED_POINT_FAILURE:
      return {
        ...state,
        isLoadingPhenomenonsForFixedPoint: false,
        error: action.payload
      };
    case actions.LOAD_CHARACTERISTICS_OF_FIXED_POINT:
      return {
        ...state,
        isLoadingCharacteristicsOfFixedPoint: true
      };

    case actions.LOAD_CHARACTERISTICS_OF_FIXED_POINT_SUCCESS:
      return {
        ...state,
        isLoadingCharacteristicsOfFixedPoint: false,
        characteristicsOfFixePoint: action.payload
      };

    case actions.LOAD_CHARACTERISTICS_OF_FIXED_POINT_FAILURE:
      return {
        ...state,
        isLoadingCharacteristicsOfFixedPoint: false,
        error: action.payload
      };

    default:
      return state;
  }
};

const { selectIds, selectEntities, selectAll, selectTotal } = entity.getSelectors();
export const selectFixedPointsIds = selectIds;
export const selectFixedPointsEntities = selectEntities;
export const selectAllFixedPoints = selectAll;
export const selectFixedPointsTotal = selectTotal;
export const selectSelectedFixedPoint = state => state.fixedPointSelect;
